import {
  Archive,
  Blog,
  Construction,
  Events,
  Home,
  InformationSquare,
  Inspection,
  Phone,
  Scales,
  ToolBox,
  Wallet,
  WarningAlt,
} from '@carbon/icons-react';
import type { NavItemConfig } from '@ui';
import type { TFunction } from 'i18next';
import { paths } from '@/app/router/paths';

/**
 * Application navigation. Labels are i18n keys resolved at render time,
 * so this file is the single place to add, reorder or hide sections.
 */
export const buildNavItems = (t: TFunction<'navigation'>): NavItemConfig[] => {
  return [
    { id: 'home', label: t('home'), href: paths.home, icon: Home },
    {
      id: 'my-permits-licenses',
      label: t('myPermitsLicenses'),
      href: paths.myPermits,
      icon: Archive,
    },
    {
      id: 'cash-management-and-billing',
      label: t('cashManagementAndBilling'),
      icon: Wallet,
      children: [
        {
          id: 'certificate-summary',
          label: t('certificateSummary'),
          href: paths.cashAndBilling.certificateSummary,
        },
      ],
    },
    {
      id: 'construction-projects',
      label: t('constructionProjects'),
      href: paths.constructionProjects,
      icon: Construction,
    },
    {
      id: 'ewr',
      label: t('emergencyWorkRequests'),
      href: paths.ewr,
      icon: WarningAlt,
    },
    {
      id: 'inspections-requests',
      label: t('inspectionsRequests'),
      href: paths.inspections,
      icon: Inspection,
    },
    { id: 'meetings', label: t('meetings'), href: paths.meetings, icon: Events },
    { id: 'news', label: t('news'), href: paths.news, icon: Blog },
    {
      id: 'resources-and-tools',
      label: t('resourcesAndTools'),
      href: paths.resourcesAndTools,
      icon: ToolBox,
    },
    {
      id: 'enforcement',
      label: t('enforcement'),
      icon: Scales,
      children: [
        {
          id: 'stop-work-orders',
          label: t('stopWorkOrders'),
          href: paths.enforcement.stopWorkOrders,
        },
        {
          id: 'notices-of-infraction',
          label: t('noticesOfInfraction'),
          href: paths.enforcement.noticesOfInfraction,
        },
      ],
    },
    { id: 'about-us', label: t('aboutUs'), href: paths.aboutUs, icon: InformationSquare },
    { id: 'contact-us', label: t('contactUs'), href: paths.contactUs, icon: Phone },
  ];
};
